import fallbackGlobalSettingsDataProvider from './FallbackGlobalSettingsDP';
export const getGlobalSettingsDataProvider = () => {
  return fallbackGlobalSettingsDataProvider;
};
//# sourceMappingURL=GlobalSettingsDataProvider.js.map